<app-header></app-header>
<app-dialog></app-dialog>
<router-outlet></router-outlet>
<app-footer [version]="this.version"></app-footer>
